<template>
	<div class="pub_tips">
		<div>遇到问题？<span class="tel">请拨打 1-808-940-9995/9996</span></div>
		<div><span class="app">WhatsApp 8089409995</span></div>
	</div>
</template>

<script>
	export default {
		name: 'PubTipsPage',
		data() {
			return {}
		},
		methods: {

		},
		created() {

		},
		beforeDestroy() {

		}
	}
</script>

<style lang="less" scoped>
	.pub_tips {
		text-align: right;
		font-size: 12px;
		line-height: 26px;

		span.tel {
			margin-left: 6px;
			display: inline-block;
			vertical-align: center;
			background-image: url(@/assets/images/icons/tips_call.png);
			background-repeat: no-repeat;
			background-position: left center;
			background-size: 12px 12px;
			padding-left: 18px;
		}

		span.app {
			margin-left: 6px;
			display: inline-block;
			vertical-align: center;
			background-image: url(@/assets/images/icons/tips_app.png);
			background-repeat: no-repeat;
			background-position: left center;
			background-size: 12px 12px;
			padding-left: 18px;
		}
	}
</style>